import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import Lockup from '../TextAndImageLockup/TextAndImageLockup'
import TypographyAtom from '../../atoms/typography/typography'
import Image from '../../atoms/images/images'
import iconFile from '../../../assets/images/icon_fileOrange.svg'
import Accordion from '../Accordion/Accordion'
import RentalProcess from '../RentalProcess/RentalProcess'
import { isEmpty } from '../../../helpers/isEmpty'
import {
  DocumentLink,
  DocumentLinkIconWrapper,
  DocumentLinkTextWrapper,
  StickyWrapper,
  TabTitle,
  WhatsInTheBoxImage,
  WhatsInTheBoxText,
  WhatsInTheBoxWrapper,
} from './ProductTabs.styles'

const ProductTabs = ({
  whatsInTheBox,
  overview,
  specification,
  documents,
  faq,
  heliguyAssist,
  isRental,
}) => {
  const existenceObject = {
    whatsInTheBox: !isEmpty(whatsInTheBox?.text),
    overview: !isEmpty(overview),
    specification: !isEmpty(specification),
    documents: !isEmpty(documents),
    faq: !isEmpty(faq),
    heliguyAssist: !isEmpty(heliguyAssist),
    rental: isRental,
  }

  if (Object.values(existenceObject).every((val) => !val)) {
    return null
  }

  return (
    <section className="outer margin-160">
      <div className="inner">
        <Tabs className="tabs">
          <TabList>
            {existenceObject.overview && (
              <Tab>
                <TabTitle>Overview</TabTitle>
              </Tab>
            )}
            {existenceObject.whatsInTheBox && (
              <Tab>
                <TabTitle>Contents</TabTitle>
              </Tab>
            )}
            {existenceObject.specification && (
              <Tab>
                <TabTitle>Specifications</TabTitle>
              </Tab>
            )}
            {existenceObject.documents && (
              <Tab>
                <TabTitle>Support</TabTitle>
              </Tab>
            )}
            {existenceObject.rental && (
              <Tab>
                <TabTitle>Rental Process</TabTitle>
              </Tab>
            )}
            {existenceObject.faq && (
              <Tab>
                <TabTitle>FAQ</TabTitle>
              </Tab>
            )}
            {existenceObject.heliguyAssist && (
              <Tab>
                <TabTitle>Heliguy Services</TabTitle>
              </Tab>
            )}
          </TabList>
          {existenceObject.overview && (
            <TabPanel>
              {overview.map((target) => (
                <Lockup
                  key={target.contentful_id}
                  id={target.contentful_id}
                  fieldsNames={{
                    heading: 'title',
                    subheading: 'subtitle',
                    body: 'body',
                    image: 'image',
                  }}
                  direction={target.direction}
                  imgSrc={target.image?.gatsbyImageData}
                  imgAltTag={target.image?.description}
                  videoFile={target.video?.file?.url}
                  heading={target.title}
                  subheader={target.subtitle}
                  body={target.body}
                />
              ))}
            </TabPanel>
          )}
          {existenceObject.whatsInTheBox && (
            <TabPanel>
              <WhatsInTheBoxWrapper isImage={!whatsInTheBox?.image}>
                <div className="row">
                  <div className={`col-xs-12 col-md-${whatsInTheBox?.image ? '4' : '12'}`}>
                    <WhatsInTheBoxText>
                      <TypographyAtom
                        type="BlockText"
                        weight="BlockText"
                        copyBlock={whatsInTheBox?.text}
                      />
                    </WhatsInTheBoxText>
                  </div>
                  <div className="col-xs-12 col-md-8 first-xs last-md">
                    <WhatsInTheBoxImage>
                      <StickyWrapper>
                        <Image
                          imgSrc={whatsInTheBox?.image}
                          // altTag={imgAltTag}
                          hasFrame="No Frame"
                          aspectRatio="None"
                        />
                      </StickyWrapper>
                    </WhatsInTheBoxImage>
                  </div>
                </div>
              </WhatsInTheBoxWrapper>
            </TabPanel>
          )}
          {existenceObject.specification && (
            <TabPanel>
              <div className="table-wrapper">
                <div
                  dangerouslySetInnerHTML={{
                    __html: specification,
                  }}
                />
              </div>
            </TabPanel>
          )}
          {existenceObject.documents && (
            <TabPanel>
              <div className="row">
                {documents?.map((target, index) => (
                  <div className="col-md-6 col-lg-4" key={index}>
                    <DocumentLink href={target.file.url} target="_blank" download>
                      <DocumentLinkIconWrapper>
                        <img src={iconFile} alt="" />
                      </DocumentLinkIconWrapper>
                      <DocumentLinkTextWrapper>
                        <h5>Support Document</h5>
                        <h4>{target.file.fileName}</h4>
                      </DocumentLinkTextWrapper>
                    </DocumentLink>
                  </div>
                ))}
              </div>
            </TabPanel>
          )}
          {existenceObject.rental && (
            <TabPanel>
              <RentalProcess />
            </TabPanel>
          )}
          {existenceObject.faq && (
            <TabPanel>
              {faq.map((target, index) => (
                <div className="margin-md" key={index}>
                  <Accordion
                    fieldsNames={{
                      header: 'faqQuestion',
                      body: 'faqAnswer',
                    }}
                    contentful_id={target.contentful_id}
                    header={target.faqQuestion}
                    body={target.faqAnswer}
                  />
                </div>
              ))}
            </TabPanel>
          )}
          {existenceObject.heliguyAssist && (
            <TabPanel>
              {heliguyAssist.map((target) => (
                <div className="margin-md" key={target.contentful_id}>
                  <Accordion
                    fieldsNames={{
                      header: 'faqQuestion',
                      body: 'faqAnswer',
                    }}
                    contentful_id={target.contentful_id}
                    header={target.faqQuestion}
                    body={target.faqAnswer}
                  />
                </div>
              ))}
            </TabPanel>
          )}
        </Tabs>
      </div>
    </section>
  )
}

export default ProductTabs
